import { TransactionType, TransactionStatus, Transaction } from "../../contract/pam.js";
import { getLastNDaysDateRange } from "../../utils/date.js";
import "react-intl";
class StatusLog {
  logged_at;
  status;
}
class TransactionDuration {
  history;
  started_at;
}
var TransactionProductType = /* @__PURE__ */ ((TransactionProductType2) => {
  TransactionProductType2["Sports"] = "Sports";
  return TransactionProductType2;
})(TransactionProductType || {});
const transactionProductTypeMapper = {
  [TransactionType.SportsBuyout]: "Sports",
  [TransactionType.SportsBetSettlement]: "Sports",
  [TransactionType.SportsBuyin]: "Sports"
  /* Sports */
};
class BoUserViewModel {
  id;
  firstName;
  lastName;
  email;
  roles;
  loginEnabled;
}
class TransactionViewModel {
  amount;
  amount_without_currency;
  counterpart_player_id;
  created_by_uid;
  currency;
  current_balance;
  duration;
  email;
  id;
  payment_method_description;
  payment_method_name;
  phone;
  player_country;
  referrer_player_id;
  register_marketing_code;
  status_log;
  transaction_id;
  transaction_started_ts;
  transaction_updated_ts;
  transaction_status;
  transaction_type;
  type;
  uid;
  username;
  withdrawal_id;
  user_labels;
  p2p_direction;
  current_casino_coin_balance;
  is_summary;
  assignee;
  last_reason;
  product_type;
  retries;
  retry_handled_at;
  error_code;
  error_json;
  turnover_rate;
  withdrawable_balance;
  transfer_amount;
  valid_bet;
  ptp_counterparty_uid;
  license_type;
  brand;
}
class TransactionDownloadModel {
  amount;
  amount_without_currency;
  counterpart_player_id;
  created_by_uid;
  currency;
  current_balance;
  duration;
  email;
  id;
  payment_method_description;
  payment_method_name;
  phone;
  player_country;
  referrer_player_id;
  status_log;
  transaction_id;
  transaction_started_ts;
  transaction_updated_ts;
  "transaction_updated_ts.seconds";
  "transaction_updated_ts.nanos";
  "transaction_started_ts.seconds";
  "transaction_started_ts.nanos";
  transaction_status;
  transaction_type;
  type;
  uid;
  username;
  withdrawal_id;
  register_marketing_code;
  user_labels;
  p2p_direction;
  current_casino_coin_balance;
  assignee;
  withdrawable_balance;
  valid_bet;
  ptp_counterparty_uid;
}
const TransactionDateRangeFilterPrefix = "startedTs";
class TransactionExtended extends Transaction {
  is_summary;
}
class TransactionFilterModel {
  text;
  types;
  paymentMethod;
  amount;
  status;
  date;
}
const retryTransactionStatuses = [TransactionStatus.Failed, TransactionStatus.InProgress];
const rangePeriodDays = 13;
const rangePeriod = getLastNDaysDateRange(rangePeriodDays);
const transactionDateDefaultFilter = [
  {
    key: "startedTs.from",
    value: rangePeriod[0]
  },
  {
    key: "startedTs.to",
    value: rangePeriod[1]
  }
];
const pendingCasesStatuses = [
  TransactionStatus.Pending,
  TransactionStatus.OnHoldRisk,
  TransactionStatus.OnHoldPayment,
  TransactionStatus.RiskAuthorized,
  TransactionStatus.InProgress
];
const closedCasesStatuses = [TransactionStatus.Rejected, TransactionStatus.Failed, TransactionStatus.Succeeded];
const pendingCasesDefaultFilter = [
  ...transactionDateDefaultFilter,
  {
    key: "transactionStatus",
    value: pendingCasesStatuses
  },
  {
    key: "defaultTransactionStatus",
    value: pendingCasesStatuses
  },
  { key: "transactionTypes", value: TransactionType.Withdrawal }
];
const closedCasesDefaultFilter = [
  ...transactionDateDefaultFilter,
  {
    key: "transactionStatus",
    value: closedCasesStatuses
  },
  {
    key: "defaultTransactionStatus",
    value: closedCasesStatuses
  },
  { key: "transactionTypes", value: TransactionType.Withdrawal }
];
var ValidationCode = /* @__PURE__ */ ((ValidationCode2) => {
  ValidationCode2[ValidationCode2["UidNotExists"] = 1e3] = "UidNotExists";
  ValidationCode2[ValidationCode2["AmountNotInteger"] = 1001] = "AmountNotInteger";
  ValidationCode2[ValidationCode2["AmountNotPositive"] = 1002] = "AmountNotPositive";
  ValidationCode2[ValidationCode2["AmountNotNumber"] = 1003] = "AmountNotNumber";
  ValidationCode2[ValidationCode2["TypeInvalid"] = 1004] = "TypeInvalid";
  ValidationCode2[ValidationCode2["ReasonInvalid"] = 1005] = "ReasonInvalid";
  ValidationCode2[ValidationCode2["LineIsTooLarge"] = 1006] = "LineIsTooLarge";
  ValidationCode2[ValidationCode2["BalanceIsNotEnough"] = 1007] = "BalanceIsNotEnough";
  ValidationCode2[ValidationCode2["AmountDecimalPartLengthIsNotValid"] = 1008] = "AmountDecimalPartLengthIsNotValid";
  ValidationCode2[ValidationCode2["AmountIsTooLarge"] = 1009] = "AmountIsTooLarge";
  ValidationCode2[ValidationCode2["TotalAmountIsTooLarge"] = 1010] = "TotalAmountIsTooLarge";
  ValidationCode2[ValidationCode2["DuplicatesNotAllowed"] = 1011] = "DuplicatesNotAllowed";
  ValidationCode2[ValidationCode2["DownlinePlayersOnlyAllowed"] = 1012] = "DownlinePlayersOnlyAllowed";
  ValidationCode2[ValidationCode2["UploadedDataIsInvalid"] = 1013] = "UploadedDataIsInvalid";
  ValidationCode2[ValidationCode2["AgentNotInP2PChannel"] = 1014] = "AgentNotInP2PChannel";
  ValidationCode2[ValidationCode2["PlayerNotInP2PChannel"] = 1015] = "PlayerNotInP2PChannel";
  return ValidationCode2;
})(ValidationCode || {});
const bulkTransactionsMaxTemplateLine = 500;
const transactionErrorCodesMapper = {
  yearAndHistoricalDoesNotMatch: "20000100",
  yearAndStartedTsYearDoesNotMatch: "20000101"
};
const bulkP2PTransferMaxTemplateLine = 5e3;
export {
  BoUserViewModel,
  StatusLog,
  TransactionDateRangeFilterPrefix,
  TransactionDownloadModel,
  TransactionDuration,
  TransactionExtended,
  TransactionFilterModel,
  TransactionProductType,
  TransactionViewModel,
  ValidationCode,
  bulkP2PTransferMaxTemplateLine,
  bulkTransactionsMaxTemplateLine,
  closedCasesDefaultFilter,
  closedCasesStatuses,
  pendingCasesDefaultFilter,
  pendingCasesStatuses,
  retryTransactionStatuses,
  transactionDateDefaultFilter,
  transactionErrorCodesMapper,
  transactionProductTypeMapper
};
//# sourceMappingURL=types.js.map
